<script setup>
import { ref, watch } from "vue";
import RadioInput from "./RadioInput.vue";

const props = defineProps({
    list: {
        type: Array,
        default: () => [],
    },
    label: {
        type: String,
        required: true,
    },
    selected: {
        type: String,
        default: "",
        required: true,
    },
    modelValue: {
        type: String,
        default: "",
    },
    dataTest: {
        type: String,
        default: "",
    },
    singleRadioElementClass: {
        type: String,
        default: "",
    },
    id: {
        type: String,
        default: "-radio",
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(["update:modelValue"]);

const selectedValue = ref("");

watch(selectedValue, () => {
    emit("update:modelValue", selectedValue.value);
});

</script>

<template>
    <div
        v-for="(item, idx) in props.list"
        :key="idx"
        class="d-flex flex-row single-radio-element"
        :class="props.singleRadioElementClass"
        :data-test="item.dataTest"
    >
        <RadioInput
            :name="'checkbox-' + item[label] + idx + `${id}`"
            :id="'checkbox-id-' + item[label] + idx + `${id}`"
            :dataTest="item.dataTest"
            v-model="selectedValue"
            :value="item.value"
            :selected="item.value === selected"
            :disabled="props.disabled"
        >
            {{ item[label] }}
        </RadioInput>
    </div>
</template>

<style scoped>
.single-radio-element {
    margin-bottom: 0.4rem;
    margin-right: 1rem;
    width: max-content;
}
</style>
